import { render, staticRenderFns } from "./modal-change-pass.vue?vue&type=template&id=54f03554"
import script from "./modal-change-pass.vue?vue&type=script&lang=js"
export * from "./modal-change-pass.vue?vue&type=script&lang=js"
import style0 from "./modal-change-pass.vue?vue&type=style&index=0&id=54f03554&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports